import { hyphenSplashSeparatedDate } from '@jfs/utils'
import alphaNumericValidation, { emailRegex } from '../../../../../src/util/regex'
import { ReportFormatEnum } from '../../../../data/models/Settlements'
import { RSAEncrypt, updateSubjectAndFile } from '../../../../util/util'

export const passwordPlaceholder = '******'

export const updatePayload = ({ values, m_id, isUpdate, getReportData, isNewPassword, response }: any): any => {
  let payload = { ...values }
  if (isUpdate) {
    payload.requestId = getReportData.requestId
  }
  if (payload.reportFormat === 'Standard' || payload.reportFormat === 'Custom') {
    payload.reportFormat = ReportFormatEnum[payload.reportFormat.toLocaleUpperCase()]
  } else if (payload.reportFormat === 'Custom RRL') {
    payload.reportFormat = ReportFormatEnum.CUSTOM_RRL
  }
  payload.reportType = 'SETTLEMENT'
  if (payload.reportValidity) {
    const reportValidity =
      typeof payload.reportValidity === 'string' ? new Date(payload.reportValidity) : payload.reportValidity
    payload.reportValidity = hyphenSplashSeparatedDate(reportValidity, 'yyyy-MM-dd hh:mm:ss')
  }
  if (payload?.fileTransferMode === 'EMAIL') {
    try {
      delete payload.emailFileTransferConfig?.sftpConfigFileName
      delete payload.emailFileTransferConfig?.sftpConfigPassKey
      delete payload.emailFileTransferConfig?.sftpConfigSubjLine
      delete payload.emailFileTransferConfig?.sftpNotifyRecipients
    } catch (error) {
      console.log('remove unwanted params')
    }
    payload = {
      ...payload,
      ...payload.emailFileTransferConfig,
    }
    updateSubjectAndFile(payload, m_id, 'emailConfigSubjLine', 'emailConfigFileName')
    payload = validatePassKey({
      payload: payload,
      isNewPassword: isNewPassword.email,
      isUpdate: isUpdate,
      response: response,
      key: 'emailConfigPassKey',
    })
  } else if (payload?.fileTransferMode === 'SFTP') {
    try {
      delete payload.sftpFileTransferConfig?.emailConfigFileName
      delete payload.sftpFileTransferConfig?.emailConfigPassKey
      delete payload.sftpFileTransferConfig?.emailConfigSubjLine
      delete payload.sftpFileTransferConfig?.emailRecipients
    } catch (error) {
      console.log('remove unwanted params')
    }
    payload = {
      ...payload,
      ...payload.sftpFileTransferConfig,
    }
    updateSubjectAndFile(payload, m_id, 'sftpConfigSubjLine', 'sftpConfigFileName')
    payload = validatePassKey({
      payload: payload,
      isNewPassword: isNewPassword.sftp,
      isUpdate: isUpdate,
      response: response,
      key: 'sftpConfigPassKey',
    })
  } else if (payload?.fileTransferMode === 'SFTP & EMAIL') {
    payload = {
      ...payload,
      ...payload.emailAndSftpFileTransferConfig,
    }
    updateSubjectAndFile(payload, m_id, 'emailConfigSubjLine', 'emailConfigFileName')
    updateSubjectAndFile(payload, m_id, 'sftpConfigSubjLine', 'sftpConfigFileName')
    const email = validatePassKey({
      payload: payload,
      isNewPassword: isNewPassword.email,
      isUpdate: isUpdate,
      response: response,
      key: 'emailConfigPassKey',
    })
    if (email !== false) {
      payload = validatePassKey({
        payload: payload,
        isNewPassword: isNewPassword.sftp,
        isUpdate: isUpdate,
        response: response,
        key: 'sftpConfigPassKey',
      })
    }
    //console.log('email, sftp', email)
  }
  delete payload?.emailFileTransferConfig
  delete payload?.sftpFileTransferConfig
  delete payload?.emailAndSftpFileTransferConfig
  return payload
}

export const updateBasedOnFileTransferMode = ({ mode, getReportData, itemData }: any) => {
  const data = JSON.parse(JSON.stringify(getReportData))
  console.log('getReportData', data)
  const regex = new RegExp(emailRegex)
  switch (mode) {
    case 'EMAIL':
      getReportData = {
        ...getReportData,
        emailFileTransferConfig: {
          emailRecipients: validEmails(getReportData.emailRecipients, regex),
          emailConfigPassKey: passwordPlaceholder, //getReportData.emailConfigPassKey,
          emailConfigSubjLine: getReportData.emailConfigSubjLine,
          emailConfigFileName: getReportData.emailConfigFileName,
        },
      }
      break
    case 'SFTP':
      getReportData = {
        ...getReportData,
        sftpFileTransferConfig: {
          sftpNotifyRecipients: validEmails(getReportData.sftpNotifyRecipients, regex),
          sftpConfigSubjLine: getReportData.sftpConfigSubjLine,
          sftpConfigFileName: getReportData.sftpConfigFileName,
          sftpConfigPassKey: passwordPlaceholder, //getReportData.sftpConfigPassKey,
        },
      }
      break
    case 'SFTP & EMAIL':
      getReportData = {
        ...getReportData,
        emailAndSftpFileTransferConfig: {
          emailRecipients: validEmails(getReportData.emailRecipients, regex), // get only valid email ids to be shown, same email regex used in the component
          emailConfigPassKey: passwordPlaceholder, //getReportData.emailConfigPassKey,
          emailConfigSubjLine: getReportData.emailConfigSubjLine,
          emailConfigFileName: getReportData.emailConfigFileName,
          sftpNotifyRecipients: getReportData.sftpNotifyRecipients,
          sftpConfigSubjLine: getReportData.sftpConfigSubjLine,
          sftpConfigFileName: getReportData.sftpConfigFileName,
          sftpConfigPassKey: passwordPlaceholder, //getReportData.sftpConfigPassKey,
        },
      }
      break
    default:
      break
  }
  delete getReportData.emailRecipients
  delete getReportData.emailConfigPassKey
  delete getReportData.emailConfigSubjLine
  delete getReportData.emailConfigFileName
  delete getReportData.sftpNotifyRecipients
  delete getReportData.sftpConfigSubjLine
  delete getReportData.sftpConfigFileName
  delete getReportData.sftpConfigPassKey
  itemData.current = getReportData
}

const validatePassKey = ({ payload, key, isNewPassword, isUpdate, response }: any) => {
  if (isNewPassword) {
    if (alphaNumericValidation.test(payload[key])) {
      const encrypted: any = RSAEncrypt(payload[key], window?._env_?.REACT_APP_PUBLIC_KEY_FOR_PASSWORD_ENC)
      payload[key] = encrypted
    } else {
      payload = false // notifiy that new password is not valid
      response?.setBgColor('RED')
      response?.setMessage(
        'Password invalid, Password must contain 8 alpha-numeric characters. Special characters are not allowed.',
      )
    }
  } else if (isUpdate && !isNewPassword) {
    //console.log('passKey not changed')
    payload[key] = '' // in update flow if password is not changed then send empty string
  }
  return payload
}

const validEmails = (list: any, regex: any) => {
  let validEmailList = []
  if (list.length) {
    validEmailList = list.filter((item: string) => item && regex.test(item?.trim()))
  }
  return validEmailList
}
